export default __webpack_public_path__ + "static/media/eth.b41b968b.svg";